import { useState } from "react";
import { BadgeCheck, MapPin, Zap, X } from "lucide-react";
import { fileSrc } from "@/components/webprofile/WpFields";

export const SERV = { fv_residenziale: "FV residenziale", fv_aziende: "FV aziende", fv_agricolo: "FV agricolo", accumulo: "Accumulo", colonnine_ev: "Colonnine EV",
  pompe_calore: "Pompe di calore", manutenzione: "Manutenzione", pratiche_incentivi: "Pratiche e incentivi", monitoraggio: "Monitoraggio", rimozione_amianto: "Rimozione amianto" };
const SOC = { facebook: "Facebook", instagram: "Instagram", linkedin: "LinkedIn", youtube: "YouTube" };

export const Cover = ({ p }) => (p?.cover ? (
  <div className="relative h-36 w-full overflow-hidden sm:h-44" data-testid="profilo-cover">
    <img src={fileSrc(p.cover)} alt="" className="h-full w-full object-cover" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#0D0F12] via-[#0D0F12]/20 to-transparent" />
    {p.claim && <p className="absolute bottom-3 left-4 right-4 font-heading text-sm font-bold text-white drop-shadow" data-testid="profilo-claim">{p.claim}</p>}
  </div>
) : null);

export const Badges = ({ p }) => {
  if (!p?.servizi?.length && !p?.certificazioni?.length && !Object.keys(p?.social || {}).length) return null;
  return (
    <div className="space-y-2 pt-2" data-testid="profilo-web-badges">
      {p.servizi?.length > 0 && <div className="flex flex-wrap gap-1.5" data-testid="profilo-servizi">{p.servizi.map((s) => <span key={s} className="rounded-full bg-[#C17F59] px-2.5 py-0.5 text-[11px] font-bold text-black">{SERV[s] || s}</span>)}</div>}
      {p.certificazioni?.length > 0 && <div className="flex flex-wrap gap-1.5" data-testid="profilo-certificazioni">{p.certificazioni.map((c) => <span key={c} className="inline-flex items-center gap-1 rounded-full border border-[#2A303C] px-2.5 py-0.5 text-[11px] text-[#D1D5DB]"><BadgeCheck className="h-3 w-3 text-[#C17F59]" />{c}</span>)}</div>}
      {Object.keys(p.social || {}).length > 0 && <div className="flex flex-wrap gap-3 text-xs" data-testid="profilo-social">{Object.entries(p.social).map(([k, u]) => <a key={k} href={u} target="_blank" rel="noreferrer" className="text-[#E5B89A] underline">{SOC[k] || k}</a>)}</div>}
    </div>
  );
};

function Lightbox({ r, onClose }) {
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto bg-black/90 p-4" onClick={onClose} data-testid="profilo-work-lightbox">
      <div className="mx-auto max-w-[600px] space-y-3" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between gap-3">
          <div><h3 className="font-heading text-lg font-bold">{r.titolo}</h3><p className="text-xs text-[#9CA3AF]">{[r.comune && `${r.comune}${r.provincia ? ` (${r.provincia})` : ""}`, r.anno, r.kwp && `${r.kwp} kWp`].filter(Boolean).join(" · ")}</p></div>
          <button type="button" onClick={onClose} className="rounded-full p-1.5 hover:bg-white/10" data-testid="profilo-work-close"><X className="h-5 w-5" /></button>
        </div>
        {r.descrizione && <p className="whitespace-pre-line text-sm text-[#D1D5DB]">{r.descrizione}</p>}
        {r.foto.map((u) => <img key={u} src={fileSrc(u)} alt="" className="w-full rounded-lg" />)}
      </div>
    </div>
  );
}

export function Works({ p }) {
  const [open, setOpen] = useState(null);
  if (!p?.realizzazioni?.length) return null;
  return (
    <section className="mt-5 px-4" data-testid="profilo-works">
      <h2 className="mb-2 text-[11px] font-bold uppercase tracking-widest text-[#9CA3AF]">Lavori realizzati</h2>
      <div className="-mx-4 flex snap-x gap-3 overflow-x-auto px-4 pb-2">
        {p.realizzazioni.map((r) => (
          <button key={r.id || r.titolo} type="button" onClick={() => setOpen(r)} data-testid={`profilo-work-${r.id}`}
            className="group w-48 shrink-0 snap-start overflow-hidden rounded-xl border border-[#2A303C] bg-[#16191E] text-left transition-colors hover:border-[#C17F59]">
            <div className="h-28 overflow-hidden"><img src={fileSrc(r.foto[0])} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" /></div>
            <div className="space-y-0.5 p-2.5">
              <div className="truncate text-sm font-bold">{r.titolo}</div>
              <div className="flex items-center gap-2 text-[11px] text-[#9CA3AF]">
                {r.comune && <span className="inline-flex items-center gap-0.5 truncate"><MapPin className="h-3 w-3" />{r.comune}</span>}
                {r.kwp && <span className="inline-flex items-center gap-0.5"><Zap className="h-3 w-3" />{r.kwp} kWp</span>}
              </div>
            </div>
          </button>
        ))}
      </div>
      {open && <Lightbox r={open} onClose={() => setOpen(null)} />}
    </section>
  );
}
